module.exports = __webpack_public_path__ + "img/orange.22f4346e.svg";